import { Routes } from '@angular/router';
import { TemplateSelectComponent } from './pages/template-select/template-select.component';
import { InvoiceFormComponent } from './pages/invoice-form/invoice-form.component';
import { InvoicePreviewComponent } from './pages/invoice-preview/invoice-preview.component';

export const INVOICE_ROUTES: Routes = [
  {
    path: '',
    component: TemplateSelectComponent
  },
  {
    path: 'form',
    component: InvoiceFormComponent
  },
  {
    path: 'form/:id',
    component: InvoiceFormComponent
  },
  {
    path: 'preview',
    component: InvoicePreviewComponent
  }
];
